import React from 'react';
import {browserHistory} from 'react-router';
import LibraryActions from 'actions/library/LibraryActions';
import {libraryShape} from 'components/Shapes';
import {LIBRARY_ROUTE} from '@store/library/library.consts';

// TODO: a must be replaced with button and eslint ignore must be removed
/* eslint jsx-a11y/anchor-is-valid: "off", no-script-url: "off" */
export default class LibraryLink extends React.PureComponent {
  handleClick(libraryId, e) {
    e.preventDefault();

    LibraryActions.searchLibrary(libraryId);
    browserHistory.push(LIBRARY_ROUTE.BASE);
  }

  render() {
    const {library} = this.props;

    return (
      <a href="#" onClick={e => this.handleClick(library.id, e)}>
        {library.name}
      </a>
    );
  }
}

LibraryLink.propTypes = {
  library: libraryShape.isRequired,
};

LibraryLink.displayName = 'LibraryLink';
